import { useLazyQuery } from "@apollo/client"
import { useShallowEffect } from "@mantine/hooks"
import CustomCard from "components/Atoms/CustomCard"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import TablePagination from "components/Molecules/TablePagination"
import BackButton from "components/Templates/BackButton"
import ModuleHeader from "components/Templates/ModuleHeader"
import { ORDER_TYPES } from "data/orderTypes"
import { useOrderFilterVariables } from "graphql/dispatch/dispatch.hooks"
import { ORDER_COUNT_FILTER } from "graphql/order/order.queries.gql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import useAuth from "hooks/useAuth"
import { isEmpty } from "lodash-es"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useCurrentDcId } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { RESET_SELECT_ALL, SELECT_ALL_FILTER } from "store/selector.redux"
import BulkUpdateDialog from "./BulkUpdateDialog"
import NewOrderActions from "./NewOrderActions"
import OrderBulkActions from "./OrderBulkActions"
import OrderFilter from "./OrderFilter"
import TotalOrders from "./TotalOrders"

const OrderTableHeader = ({ children }) => {
  const isAllSelected = useSelector(
    state => state.selector?.orders?.selectAllFilter
  )
  const [{ search, page }, setFilter] = useSearchFilter()
  const [filter, setOrderFilter] = useFilter("orders")
  const { user, distributionCentres } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname
  const dispatch = useDispatch()
  const orderFilter = useOrderFilterVariables()
  const dcId = useCurrentDcId()

  const [getCountFilter, { data }] = useLazyQuery(ORDER_COUNT_FILTER)

  useShallowEffect(() => {
    if (isEmpty(filter)) {
      setOrderFilter({
        orderCategories: ORDER_TYPES.filter(ot => ot.id === "T0"),
        placedInId: filter?.placedInId
          ? filter?.placedInId
          : user?.currentDepartment,
        distributionCentreIds: distributionCentres?.filter(
          dc => dc.id === dcId
        ),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  useEffect(() => {
    if (isAllSelected) {
      getCountFilter({ variables: { filter: orderFilter } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllSelected])

  return (
    <div className="p-3">
      <CustomCard className="p-0">
        <ModuleHeader
          filter={<OrderFilter />}
          borderBottom="none"
          query={search ?? ""}
          onQueryChange={search => {
            setFilter(prev => ({
              ...prev,
              search,
              page: 0,
            }))
          }}
          white
          className="p-3"
          header={
            path.includes("sellable-items") ? (
              <BackButton
                text="All Orders"
                onClick={() => {
                  navigate("/d/ecom/orders", { replace: true })
                }}
              />
            ) : (
              <div className="d-center">
                {/* <span className="vt-text">
                  <OrderSwitch
                    className="mr-3"
                    active={
                      filter
                        ? filter.orderCategories
                        : ORDER_TYPES.filter(ot => ot.id === "T0")
                    }
                    onClick={type => {
                      setOrderFilter({
                        ...filter,
                        orderCategories: ORDER_TYPES.filter(
                          ot => ot.id === type
                        ),
                        placedInId: filter.placedInId
                          ? filter.placedInId
                          : user?.currentDepartment,
                      });
                    }}
                  />
                </span> */}
                <TotalOrders
                  isCountFilter={isAllSelected}
                  count={data?.orderCountFilter}
                />
                <CustomCheckbox
                  className="my-auto ml-2"
                  checked={isAllSelected}
                  onChange={() =>
                    dispatch({
                      type: SELECT_ALL_FILTER,
                      path: "orders",
                    })
                  }
                >
                  Select All
                </CustomCheckbox>
              </div>
            )
          }
        >
          <TablePagination
            className="mr-3"
            page={page}
            onPageChange={pg => {
              setFilter(prev => ({
                ...prev,
                page: pg,
              }))
              if (pg > page) {
                dispatch({
                  type: RESET_SELECT_ALL,
                  path: "orders",
                })
              }
            }}
          />
          <OrderBulkActions
            isCountFilter={isAllSelected}
            count={data?.orderCountFilter}
          />
          <NewOrderActions
            className="ml-3"
            isCountFilter={isAllSelected}
            count={data?.orderCountFilter}
          />
        </ModuleHeader>
        <BulkUpdateDialog />
        {children}
      </CustomCard>
    </div>
  )
}

export default OrderTableHeader
